import React, { useRef, useEffect, useState } from 'react'
import config from 'config'

import usePersistedState from 'core/hooks/use-persisted-state'

import Video from 'core/assets/video/flag-loop.mp4'
import Poster from 'core/assets/posters/flag-loop.jpg'

const LoadingVideo = props => {
  const videoRef = useRef()
  const [hidden, setHidden] = usePersistedState('loadingVideoDismissed', 0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setHidden(1)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (!!hidden && videoRef.current) {
      videoRef.current.pause()
    }
  }, [hidden])

  return (
    <div className={`loading-video is-${hidden ? 'hidden' : 'showing'}`}>
      <video
        className="loading-video-player"
        src={`${config.themePath}/public/${Video}`}
        poster={`${config.themePath}/public/${Poster}`}
        loop
        autoPlay
        muted
        ref={videoRef}
      />
    </div>
  )
}

export default LoadingVideo
